(function () {
  'use strict';

  var STORAGE_KEY = 'shrine_currency_country';
  var STORAGE_TS  = 'shrine_currency_ts';
  var CACHE_HOURS = 24;

  function getCached() {
    try {
      var age = (Date.now() - parseInt(localStorage.getItem(STORAGE_TS) || '0')) / 3600000;
      if (age < CACHE_HOURS) return localStorage.getItem(STORAGE_KEY);
    } catch(e) {}
    return null;
  }

  function setCache(code) {
    try {
      localStorage.setItem(STORAGE_KEY, code);
      localStorage.setItem(STORAGE_TS, Date.now().toString());
    } catch(e) {}
  }

  function getCountries() {
    var map = {};
    document.querySelectorAll('#HeaderCurrencyList [data-value]').forEach(function(el) {
      map[el.dataset.value.toUpperCase()] = el;
    });
    return map;
  }

  function getCurrentCountry() {
    var active = document.querySelector('#HeaderCurrencyList .disclosure__link--active');
    return active ? active.dataset.value : null;
  }

  function applyCountry(code, countries) {
    var option = countries[code.toUpperCase()];
    if (!option) return false;
    if (option.dataset.value === getCurrentCountry()) return true;
    var input = document.getElementById('HeaderCurrencyInput');
    if (input) input.value = code;
    option.click();
    return true;
  }

  function fetchCountry() {
    return fetch('https://ipapi.co/country/')
      .then(function(r) { return r.text(); })
      .then(function(t) {
        var c = t.trim().toUpperCase();
        if (/^[A-Z]{2}$/.test(c)) return c;
        throw new Error('bad');
      })
      .catch(function() {
        return fetch('https://ipinfo.io/country')
          .then(function(r) { return r.text(); })
          .then(function(t) {
            var c = t.trim().toUpperCase();
            if (/^[A-Z]{2}$/.test(c)) return c;
            throw new Error('bad');
          });
      });
  }

  function initDropdown() {
    var btn      = document.getElementById('HeaderCurrencyBtn');
    var dropdown = document.getElementById('HeaderCurrencyDropdown');
    if (!btn || !dropdown) return;

    btn.addEventListener('click', function() {
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!open));
      dropdown.hidden = open;
    });

    document.addEventListener('click', function(e) {
      if (!btn.contains(e.target) && !dropdown.contains(e.target)) {
        btn.setAttribute('aria-expanded', 'false');
        dropdown.hidden = true;
      }
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        btn.setAttribute('aria-expanded', 'false');
        dropdown.hidden = true;
        btn.focus();
      }
    });

    dropdown.querySelectorAll('[data-value]').forEach(function(el) {
      el.addEventListener('click', function(e) {
        e.preventDefault();
        var flag = document.getElementById('header-currency-flag');
        var sym  = btn.querySelector('.header-currency-selector__symbol');
        if (flag) flag.textContent = el.dataset.currency || el.dataset.value;
        if (sym)  sym.textContent  = el.dataset.symbol || '';
        var input = document.getElementById('HeaderCurrencyInput');
        if (input) input.value = el.dataset.value;
        setCache(el.dataset.value);
        var form = el.closest('localization-form');
        if (form) form.dispatchEvent(new Event('submit', { bubbles: true }));
        btn.setAttribute('aria-expanded', 'false');
        dropdown.hidden = true;
      });
    });
  }

  function init() {
    initDropdown();
    var countries = getCountries();
    if (!Object.keys(countries).length) return;

    var cached = getCached();
    if (cached) {
      if (cached !== getCurrentCountry()) applyCountry(cached, countries);
      return;
    }

    fetchCountry().then(function(code) {
      setCache(code);
      if (code !== getCurrentCountry()) applyCountry(code, countries);
    }).catch(function() {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();